var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyWithMagGlass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299.999,
    height: 172.607,
    viewBox: "0 0 299.999 172.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fafafa}.cls-2{fill:#bac0cd}.cls-3,.cls-5{fill:#cdd2dc}.cls-4{fill:#e9edf1}.cls-5{font-size:22px;font-family:PTMono-Bold,PT Mono;font-weight:700}.cls-6{fill:#bbc1ce}.cls-7{fill:#fff}.cls-8{fill:#ccd4dc}.cls-10{fill:#011627}.cls-11{fill:#474e5d}.cls-14{fill:#753bbd}.cls-15{fill:#8a5aea}.cls-16{fill:#c3c8cf}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5226",
    transform: "translate(-587.999 -477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    transform: "translate(-11232.524 -19951.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no_results",
    transform: "translate(11820.523 20430.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    d: "M267.423 169.265a47.822 47.822 0 0 1-18.54-14.553c-19.073-26.515 10.456-55.21 1.259-91.5C242.01 30.515 205.607 2.274 169.395.09 147.468-1 116.146 5.728 103.562 25.6c-7.164 11.235-1.84 16.235-9 25.559C79.5 70.76 50.993 56.526 25.433 75.49 4.181 91.047 1.131 117.511.454 123.332a76.06 76.06 0 0 0 10.357 47.206z",
    className: "cls-1",
    transform: "translate(-.007 .023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    d: "M298.062 37.18H.22l.454 2.42h297.838z",
    className: "cls-1",
    transform: "translate(1.488 130.967)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    transform: "translate(258.203 85.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5133"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2454",
    cx: 11.482,
    cy: 16.649,
    className: "cls-2",
    rx: 11.482,
    ry: 16.649,
    transform: "translate(5.741)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2455",
    cx: 16.649,
    cy: 16.649,
    r: 16.649,
    className: "cls-2",
    transform: "translate(0 22.964)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20229",
    d: "M-16313.819 5724.272l-5.282 73.148h4.6z",
    className: "cls-3",
    transform: "translate(16330.466 -5713.626)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4306",
    d: "M0 0H4.77V9.541H0z",
    className: "cls-4",
    transform: "translate(49.2 70.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4307",
    d: "M0 0H4.77V9.541H0z",
    className: "cls-4",
    transform: "translate(52.375 78.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4308",
    d: "M0 0H4.77V9.541H0z",
    className: "cls-4",
    transform: "translate(66.664 102.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4338",
    d: "M0 0H4.77V9.541H0z",
    className: "cls-4",
    transform: "translate(46.527 70.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4339",
    d: "M0 0H4.77V9.541H0z",
    className: "cls-4",
    transform: "translate(49.702 78.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4340",
    d: "M0 0H4.77V9.541H0z",
    className: "cls-4",
    transform: "translate(63.991 102.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5218",
    transform: "translate(30.738 85.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5133-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2454-2",
    cx: 11.482,
    cy: 16.649,
    className: "cls-2",
    rx: 11.482,
    ry: 16.649,
    transform: "translate(5.741)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2455-2",
    cx: 16.649,
    cy: 16.649,
    r: 16.649,
    className: "cls-2",
    transform: "translate(0 22.964)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20229-2",
    d: "M-16313.819 5724.272l-5.282 73.148h4.6z",
    className: "cls-3",
    transform: "translate(16330.466 -5713.626)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    transform: "translate(5.247 85.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5133-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2454-3",
    cx: 11.482,
    cy: 16.649,
    className: "cls-2",
    rx: 11.482,
    ry: 16.649,
    transform: "translate(5.741)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2455-3",
    cx: 16.649,
    cy: 16.649,
    r: 16.649,
    className: "cls-2",
    transform: "translate(0 22.964)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20229-3",
    d: "M-16313.819 5724.272l-5.282 73.148h4.6z",
    className: "cls-3",
    transform: "translate(16330.466 -5713.626)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    className: "cls-5",
    transform: "rotate(45 -12.518 311.145)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    className: "cls-5",
    transform: "rotate(-45 152.822 -53.335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    className: "cls-5",
    transform: "translate(127.334 37.628)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4311",
    d: "M0 0H299.999V4H0z",
    className: "cls-3",
    transform: "translate(587.999 645.607)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5223",
    transform: "translate(651.633 587.242)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2448",
    cx: 14.261,
    cy: 15.906,
    className: "cls-6",
    rx: 14.261,
    ry: 15.906,
    transform: "translate(60.333 28.357)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2449",
    cx: 14.261,
    cy: 15.906,
    className: "cls-6",
    rx: 14.261,
    ry: 15.906,
    transform: "translate(163.451 29.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20218",
    d: "M-16169.719 5770.807v-16.259l26.946-3.728 19.449-15.67 80.059 1.014 25.573 17.054 50.164 11.341 4.1 8.382h2.255v6.581l-209.223-.017-1.917-8.7z",
    className: "cls-3",
    transform: "translate(16173.069 -5735.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20225",
    d: "M-16327.91 5811.805l47.577 11.424-4.944 9.1 51.088.333v-2.2h-2.314l-4.084-8.454-51.062-11.721z",
    className: "cls-3",
    transform: "translate(16446.137 -5792.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20219",
    d: "M-16101.078 5737.923v16.735h35.738l-13.234-16.735z",
    className: "cls-6",
    transform: "translate(16179.979 -5734.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20220",
    d: "M-16101.982 5737.923h-19.27l-14 13.4v3.46h31.726z",
    className: "cls-6",
    transform: "translate(16176.662 -5734.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20221",
    d: "M-16076.074 5737.923l26.551.017 22.283 14.821-36.9 1.27z",
    className: "cls-6",
    transform: "translate(16182.4 -5734.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4295",
    d: "M0 0H213.914V5.485H0z",
    className: "cls-6",
    transform: "translate(0 39.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20222",
    d: "M-16002.2 5763.073h-18.918l-2.956 5.61h24.424z",
    className: "cls-7",
    transform: "translate(16187.446 -5732.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20223",
    d: "M-15984.682 5763.073h-4.15v5.563h6.848z",
    className: "cls-7",
    transform: "translate(16190.863 -5732.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20224",
    d: "M-16104.53 5754.961v8.744s5.538-.725 5.624 2.423 0 4.361 0 4.361h36v-15.528z",
    className: "cls-3",
    transform: "translate(16179.644 -5733.229)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2450",
    cx: 14.261,
    cy: 15.906,
    className: "cls-6",
    rx: 14.261,
    ry: 15.906,
    transform: "translate(19.746 30.551)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2451",
    cx: 14.261,
    cy: 15.906,
    className: "cls-6",
    rx: 14.261,
    ry: 15.906,
    transform: "translate(122.862 30.551)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2452",
    cx: 6.582,
    cy: 7.679,
    className: "cls-7",
    rx: 6.582,
    ry: 7.679,
    transform: "translate(27.423 39.327)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2453",
    cx: 6.582,
    cy: 7.679,
    className: "cls-7",
    rx: 6.582,
    ry: 7.679,
    transform: "translate(130.541 39.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20226",
    d: "M-7.036-.843H.1l12.645 15.56-7.705.234z",
    className: "cls-7",
    transform: "translate(120.294 3.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20227",
    d: "M-2.3-.864h1.629l12.516 15.883-1.7.1z",
    className: "cls-7",
    transform: "translate(111.956 3.905)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4297",
    width: 4.77,
    height: 1.59,
    className: "cls-7",
    rx: 0.795,
    transform: "translate(79.922 23.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4298",
    d: "M2 0h6.541a1 1 0 0 1 1 1v5.36H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    className: "cls-3",
    transform: "translate(105.364 17.163)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5224",
    transform: "translate(690.516 477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5212",
    transform: "translate(9.204 58.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20294",
    d: "M21885.262 11927.682s.328-1.287 3.117-1.336 1.15 4.272.887 5.752-1.928.16-1.928.16z",
    className: "cls-8",
    transform: "translate(-21884.432 -11921.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20295",
    d: "M22605.227 11842.146a20.855 20.855 0 0 1-1.129-3.574c-.746-2.854-1.01-1.812 0 3.083l-1.729-3.678s-.66-1.611-.723-1.067a42.742 42.742 0 0 0 1.174 4.864s-.953-2.383-1.422-3.4-.588-.707-.525 0 1 3.94 1 3.94a24.526 24.526 0 0 0-1.408-2.257c-.461-.566-.541-.56-.436 0s.842 2.8.842 2.8z",
    className: "cls-8",
    transform: "translate(-22599.99 -11836.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20296",
    d: "M22603.434 11842.154a4.986 4.986 0 0 1 .863-2.17c.6-.581.059-.994-.594-.538s-.834 1.812-.834 1.812z",
    className: "cls-8",
    transform: "translate(-22597.895 -11835.351)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20297",
    d: "M21862.668 11823.293s-2.973.518-2.287-4.561 2.287-16.314 2.287-16.314.838-1.471 1.684 0 2.121 16.314 2.121 16.314a6.1 6.1 0 0 1-1.734 3.463c-1.466 1.285-2.071 1.098-2.071 1.098z",
    className: "cls-8",
    transform: "translate(-21850.52 -11734.302)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20298",
    fill: "#cdd2dc",
    d: "M34.783 0A34.783 34.783 0 1 1 0 34.783 34.783 34.783 0 0 1 34.783 0z",
    opacity: 0.467,
    transform: "rotate(64 47.062 75.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4336",
    d: "M0 0H5.565V25.044H0z",
    className: "cls-6",
    transform: "rotate(64 -22.99 68.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4337",
    d: "M0 0h11.13v31.391a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V0z",
    className: "cls-10",
    transform: "rotate(64 -37.172 56.62)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    transform: "translate(10.635 58.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    d: "M56.6 36.22v2.639h-1.66v-2.19z",
    className: "cls-11",
    transform: "translate(-16.969 71.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    d: "M57.619 36.49a11.775 11.775 0 0 0 3.281 1.094c1.849.339 3.472 0 4.113 1.057a1.057 1.057 0 0 1 0 .453H54.94v-2.6c.528.528.793.679 1.246.453a.83.83 0 0 0 .415-.415z",
    className: "cls-10",
    transform: "translate(-16.969 73.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    d: "M50.82 36.12v2.148h1.66v-1.924z",
    className: "cls-11",
    transform: "translate(-36.348 72.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    d: "M56.126 36.49a11.774 11.774 0 0 1-3.282 1.094c-1.849.339-3.472 0-4.113 1.057a1.056 1.056 0 0 0-.189.453H58.8v-2.6c-.528.528-.793.679-1.246.453a.83.83 0 0 1-.415-.415z",
    className: "cls-10",
    transform: "translate(-42.674 73.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20282",
    fill: "#313948",
    d: "M21866.9 11829.615l2.139 60.42h5.65s.314-38.936 1.324-43.752 1.521-4.2 4.451 2.85 13.646 40.9 13.646 40.9l5.092-.521s-7.766-45.473-15.5-60.921-16.802 1.024-16.802 1.024z",
    transform: "translate(-21857.254 -11780.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_41",
    d: "M2.14 61.662L0 1.244S.275.744.77 0h10.524v15.752c-1.065-1.826-1.513-1.011-2.18 2.16-1.014 4.815-1.326 43.75-1.326 43.75z",
    className: "cls-10",
    transform: "translate(9.647 47.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20280",
    d: "M3.391 1.61c-.715 2.509-1.334 3.835.958 5.084S.767 6.451.209 5.317s.1-2.863.81-4.1S4.1-.906 3.391 1.61z",
    className: "cls-8",
    transform: "rotate(-42 77.16 -9.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    fill: "#535d6b",
    d: "M52.9 8.26h.264c.264 0 .491.264.566.339a.905.905 0 0 1 .189.566.943.943 0 0 0-.641-.905z",
    transform: "translate(-30.58 1.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    d: "M51.36 9.042a8.151 8.151 0 0 1 3.282 2.113 8.3 8.3 0 0 1 1.962 6.3 8.755 8.755 0 0 1-1.66 4.566H60.3l-2.754-.981v-5.4l.566-.528a4.679 4.679 0 0 0 .905-6.378 4.831 4.831 0 0 0-6.187-1.012 4.491 4.491 0 0 0-1.47 1.32z",
    className: "cls-8",
    transform: "translate(-34.849 -1.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20275",
    d: "M21878.01 11808.908c-3.771-.77-9.529 2.646-12.244 3.441a6.749 6.749 0 0 0-4.879 7.443c.453 4.064 12.145 0 12.145 0s8.749-10.113 4.978-10.884z",
    className: "cls-14",
    transform: "translate(-21860.836 -11788.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20273",
    d: "M21867.84 11817.488s-.965-6.8 3.184-7.971 10.172-2.206 13.375-.629 4.77 11.084 3 17.594-3 11.316-3 11.316h-17.533s1.859-6.421 1.859-10.434a83.3 83.3 0 0 0-.885-9.876z",
    className: "cls-15",
    transform: "translate(-21857.271 -11789.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20274",
    d: "M21878.945 11808.64s16.824 11.442 12.977 15.406-5.426 2.11-7.057 1.327-8.475-5.32-8.475-5.32z",
    className: "cls-15",
    transform: "translate(-21851.65 -11788.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_38",
    d: "M2.319 5.857C1.225 3.837.363 1.951 0 1.132A28.631 28.631 0 0 1 9.709.107C8.4 2.314 5.893 6.458 5.154 7.089c-.46.394-.786.731-1.14.731-.428 0-.898-.49-1.695-1.963z",
    className: "cls-8",
    transform: "translate(14.869 18.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20281",
    d: "M21886.48 11819.016l-8.211 12.5 1.488.175s11.621-7.223 12.168-8.477.834-5.474-1.018-5.66-4.427 1.462-4.427 1.462z",
    className: "cls-8",
    transform: "translate(-21850.543 -11783.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_39",
    d: "M0 17.6s1.86-6.423 1.86-10.436A66.029 66.029 0 0 0 1.332 0c1.314 1.249 4.85 4.783 4.9 6.694.068 2.348-.984 2.224-2.754 5.606-.972 1.857 1.752 3.864 4.407 5.3z",
    className: "cls-14",
    transform: "translate(9.594 31.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    d: "M52.611 8.909a5.961 5.961 0 0 0-.83 1.246 10.793 10.793 0 0 0-.566 8.189H54.8v2.6l-2.868 1.17 7.547-.982v-5.393l2.34-2.909a5.736 5.736 0 0 0-1.548-4.265 5.434 5.434 0 0 0-6.225-1.015 4 4 0 0 0-1.434 1.359z",
    className: "cls-8",
    transform: "translate(-36.779 -1.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_40",
    d: "M7.913 12.327l.194.072a.854.854 0 0 1-.194-.072zm-3.757-8.7A34.418 34.418 0 0 1 0 .669 6.015 6.015 0 0 1 .484 0l8.807 1.208a5.737 5.737 0 0 1 .471 2.633L7.422 6.75v5.133C6.069 10.1 5.5 4.413 4.156 3.629z",
    className: "cls-16",
    transform: "translate(15.279 7.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20272",
    d: "M21874.543 11793.5s-3.494-1.922-1.822 3.424 8.99 7.518 8.99 7.518l-.262 3.864 6.191-6.474s-3.25-6.01-7.7-7.237-5.397-1.095-5.397-1.095z",
    className: "cls-10",
    transform: "translate(-21858.854 -11793.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20279",
    d: "M21874.674 11804.579s2.127-2.431 2.178-.536a1.827 1.827 0 0 1-1.893 1.89z",
    className: "cls-16",
    transform: "translate(-21852.668 -11791.941)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20299",
    d: "M0 51.069L32.768 0l8.3 3.873L7.667 57.23z",
    className: "cls-7",
    transform: "rotate(28 11.416 153.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20300",
    fill: "none",
    stroke: "#fcfcfc",
    d: "M0 51.879L32.032 0",
    transform: "rotate(28 -7.648 173.55)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_20293",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.783 0A34.783 34.783 0 1 1 0 34.783 34.783 34.783 0 0 1 34.783 0z",
    transform: "rotate(64 47.062 75.314)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bbc1ce",
    d: "M34.783 4c-4.158 0-8.189.813-11.981 2.417-3.665 1.55-6.958 3.77-9.786 6.599-2.828 2.828-5.048 6.12-6.599 9.786C4.813 26.594 4 30.625 4 34.782c0 4.158.813 8.189 2.417 11.981 1.55 3.666 3.77 6.958 6.599 9.786 2.828 2.829 6.12 5.049 9.786 6.599 3.792 1.604 7.823 2.417 11.98 2.417 4.158 0 8.189-.813 11.981-2.417 3.666-1.55 6.958-3.77 9.786-6.599 2.829-2.828 5.049-6.12 6.599-9.786 1.604-3.792 2.417-7.823 2.417-11.98 0-4.158-.813-8.189-2.417-11.981-1.55-3.665-3.77-6.958-6.599-9.786-2.828-2.828-6.12-5.048-9.786-6.599C42.971 4.813 38.94 4 34.783 4m0-4c19.21 0 34.782 15.573 34.782 34.783S53.993 69.565 34.783 69.565C15.573 69.565 0 53.993 0 34.783 0 15.573 15.573 0 34.783 0z",
    transform: "rotate(64 47.062 75.314)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyWithMagGlass);
export default __webpack_public_path__ + "static/media/guy-with-mag-glass.d4ed1b1ab1dad9648e907857a25ab1cd.svg";
export { ForwardRef as ReactComponent };